module.exports = __webpack_public_path__ + "static/media/fo.65d72754.svg";